import { render, staticRenderFns } from "./cliente-gerenciar.vue?vue&type=template&id=49787a95&"
import script from "./cliente-gerenciar.vue?vue&type=script&lang=js&"
export * from "./cliente-gerenciar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports